<template>
<div class="chapter">
<div class="inner_page">
<div aria-label="1" epub:type="pagebreak" id="page1" role="doc-pagebreak"></div>
<div aria-label="5" epub:type="pagebreak" id="page5" role="doc-pagebreak"></div>
<div id="_idContainer009">
<p class="dedication"><span class="Italic-Style">For Marion &amp; Russell Weis
				</span></p>
<p class="dedication-space-before"><span class="Italic-Style">We have all heard stories
					of the problems caused by poor relationships with mothers- and fathers-in-law. I
					have had no such issues. Instead, I gained two loving parents who have treated
					me as a son for more than three decades. As I myself have transitioned into the
					role of father-in-law, their model as to how to give space, and give love—with
					open arms and no preconditions—continues to guide and inform me.</span></p>
</div>
<div aria-label="7" epub:type="pagebreak" id="page7" role="doc-pagebreak"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781504095785.vue?37defecb